<template>
  <div class="statusTextMainWrapper">
    <span v-if="status" class="status" :class="status">
      {{ $t(`band.submission.status.${status}`).toUpperCase() }}
    </span>
    <span class="period">·</span>
    <span class="date">{{ formatted_date }}</span>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import date_utils from '~/mixins/shared/dateUtils'

export default defineComponent({
  mixins: [date_utils],
  props: {
    status: {
      type: String,
      required: true,
      default() {
        return ''
      },
    },
    date: {
      type: String,
      required: true,
      default() {
        return ''
      },
    },
  },
  computed: {
    formatted_date() {
      return this.formatToTextFullDate(this.date)
    },
  },
  watch: {
    status() {
      return this.status
    },
  },
})
</script>

<style scoped>
.statusTextMainWrapper {
  position: relative;
  width: 100%;
  display: flex;
}

.status {
  font-size: var(--font-size-small);
  font-weight: 600;
}

.period {
  color: var(--color-black);
  font-size: var(--font-size);
  margin-left: 4px;
  margin-right: 4px;
}

.date {
  color: var(--color-darker-grey);
  font-size: var(--font-size-small);
}

.Ex {
  color: var(--color-darker-grey);
}

.Wa,
.Wc {
  color: var(--color-dark-kero);
}

.Fn-Wa {
  color: var(--color-param);
}

.Fn-Wc {
  color: var(--color-cute);
}

.Fn {
  color: var(--color-main);
}
</style>
